export const setIbLeadDetailsaction = (leaddetail) => ({
    type: 'SET_IBLEADDETAIL',
    payload: leaddetail,
  });
  